import React from 'react';

import {createHashRouter} from 'react-router-dom';
import NotFound from "../error/NotFound";
import OtherPage from "./OtherPage";
import OtherPage2 from "./OtherPage2";
import RouteList from "./RouteList";
import DevSandbox from "../../dashboard/dev-sandbox/DevSandbox";
import DatasetWindow from "../../dashboard/dataset-window";
import VikingMaltBestBatchCalculator
    from "../../company-specific/viking-malt/best-batch-calculator/VikingMaltBestBatchCalculator";
import EasasMainLayout from "./EasasMainLayout";

export const easasMainRouter = createHashRouter([
    { path: "/", element: <EasasMainLayout/>,
        children: [
            { index: true, element: <RouteList/> },
            { path: "/sandbox", element: <DevSandbox/> },
            { path: "/datasets", element: <DatasetWindow/> },
            { path: "/instant-job-run", element: <VikingMaltBestBatchCalculator/> },
            { path: "/dashboard", element: <NotFound/> },
            { path: "/other-page", element: <OtherPage/>,
                children: [
                    {
                        path: ":pageId",
                        element: <OtherPage2/>,
                    }
                ]
            },
            { path: "/other-page-2/:pageId", element: <OtherPage2/>},
            { path: "/*", element:  <NotFound/> },
        ],
    },
]);